var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuFold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4h-5.906v12H16V4zm-5.906-1.5H4A1.5 1.5 0 002.5 4v12A1.5 1.5 0 004 17.5h12a1.5 1.5 0 001.5-1.5V4A1.5 1.5 0 0016 2.5h-5.906zM4 16h4.594V4H4v12zm3.188-9.75H5.313v1.5h1.875v-1.5zm0 2.813H5.313v1.5h1.875v-1.5zm-1.875 2.812h1.875v1.5H5.313v-1.5z",
    fill: "#939CAD"
  })));
}
export default __webpack_public_path__ + "static/menu-fold.f46fdac1.svg";
export { SvgMenuFold as ReactComponent };